export default __webpack_public_path__ + "static/media/Porsh.a91dc505.png";